import React from "react";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";
import BookImg from "../../assets/book.svg";
import { FaArrowRight } from "react-icons/fa6";
import { FaArrowLeft } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { storyImages, headerImages } from "../../utils/constants";
import PreLoadingImages from "../custom/PreLoadingImages";

const OurStory = () => {
  const NextArrow = ({ onClick }) => (
    <div
      className="absolute bg-white top-[45%] sm:top-[55%] lg:top-[50%] right-[-12px] sm:right-[-35px] transform -translate-y-1/2 text-[22px] text-[#D31C4F] w-7 h-7 flex items-center justify-center rounded-full p-2 cursor-pointer ml-[5vw] z-10"
      onClick={onClick}
    >
      <FaArrowRight />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className="absolute bg-white top-[45%] sm:top-[55%] lg:top-[50%] left-[-10px] sm:left-[-35px] transform -translate-y-1/2  text-[22px] text-[#D31C4F] w-7 h-7 flex items-center justify-center rounded-full p-2 cursor-pointer z-10"
      onClick={onClick}
    >
      <FaArrowLeft />
    </div>
  );

  const images = [
    headerImages.mobileDignitariesHeaderImg,
    headerImages.dignitariesHeaderImg,
    headerImages.mobileFacilitiesHeaderImg,
    headerImages.facilitiesHeaderImg,
    headerImages.mobileEventsHeaderImg,
    headerImages.eventsHeaderImg,
    headerImages.mobileActivitiesHeaderImg,
    headerImages.activitiesHeaderImg,
    headerImages.mobileCelebrationsHeaderImg,
    headerImages.celebrationsHeaderImg,
    headerImages.mobilePositiveParentingHeaderImg,
    headerImages.positiveParentingHeaderImg,
  ];

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 5000,
    cssEase: "linear",
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div
      id="story"
      className="flex flex-col lg:flex-row-reverse gap-[50px]  lg:gap-[100px] items-center px-[3%] lg:px-[8%] py-[30px] lg:py-[60px] "
    >
      <PreLoadingImages images={images} />
      <div className="lg:w-[700px] relative flex  flex-col justify-center">
        <CustomHeading
          text={"Our "}
          textSize="54px"
          leading="68px"
          customImg={BookImg}
          heartHeight="60px"
          heartWidth="80px"
          spanText={"Story"}
          spanTextColor="#d31c4f"
          smTextSize="32px"
        />
        <CustomContent
          marginTop="0px"
          leading="28px"
          textSize="18px"
          textAlign="justify"
          fontWeight={500}
          textColor="#636363"
          text={`Our journey began in 1996 with a vibrant, thoughtfully designed school
          in Paschim Vihar, pioneering a new approach to early childhood
          education. Since then, Mother's Pride has set the benchmark for
          preschools, growing to over 110+ branches—and counting!`}
        />
        <CustomContent
          marginTop="10px"
          leading="28px"
          textSize="18px"
          textAlign="justify"
          fontWeight={500}
          textColor="#636363"
          text={`We remain the only preschool with a dedicated Research & Development
          department. Our teachers undergo continuous training in the latest
          child psychology insights, ensuring every child gets the best
          foundation. A team of 700+ passionate pedagogues, educators, along
          with 200+ quality managers and academic experts, work tirelessly to
          shape young minds into future leaders. Beyond education, we empower
          parents with guidance on positive parenting through enriching
          seminars—fostering a world where love, learning, and happiness go hand
          in hand. Welcome to Mother's Pride, where every child is cherished,
          every dream is nurtured, and love truly blossoms.`}
        />
      </div>
      <Slider
        {...settings}
        className=" mb-[50px] md:max-w-[600px] bg-transparent lg:mb-[0px] rounded-lg mx-auto px-[20px] w-[88%] sm:w-[90%] lg:w-[570px]"
      >
        {storyImages?.map((item, index) => (
          <div className="px-[10px]">
            <img
              className="shadow-md sm:w-full w-[270px]  md:max-w-[600px] lg:min-w-[500px] rounded-xl"
              src={window.innerWidth < 450 ? item?.mobileImg : item?.img}
              alt={`image-${index}`}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default OurStory;
